import React from 'react';
import { FaHeart, FaShareAlt } from 'react-icons/fa';

const CourseHeader = ({ breadcrumb, title, subtitle }) => {
  return (
    <div className="course-header">
      <div className="breadcrumb">
        {breadcrumb.map((item, index) => (
          <div className="breadcrumb-item" key={index}>
            <span className="breadcrumb-link">{item}</span>
            {index < breadcrumb.length - 1 && (
              <span className="breadcrumb-separator">›</span>
            )}
          </div>
        ))}
      </div>
      
      <div className="course-title-container">
        <div className="course-title-content">
          <h1 className="course-title">{title}</h1>
          <h2 className="course-subtitle">{subtitle}</h2>
        </div>
        
        <div className="course-actions">
          <button className="action-button">
            <FaHeart /> 收藏
          </button>
          <button className="action-button">
            <FaShareAlt /> 分享
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseHeader; 